const buildCompleteUrl = (rootUrl, confirmId, reservationToken, useDefaultTheme, widgetTemplateId) => {
  const query = new URLSearchParams();
  if (useDefaultTheme) query.set("default_theme", "true");
  if (widgetTemplateId) query.set("widget_template_id", widgetTemplateId);
  const queryString = query.toString();

  return rootUrl + "confirms/" + confirmId + "/ticket_reservations/" + reservationToken + "/complete" +
    (queryString ? "?" + queryString : "");
};

export default buildCompleteUrl;
